<template src="./index.html" />
<script>
import { validationMixin } from 'vuelidate';
import {
  required, email, minLength,
} from 'vuelidate/lib/validators';
import AWS from '@/services/AwsSdk';
import ConverEmailToLowerCase from '@/mixins/ConverEmailToLowerCase';
/* eslint-disable vue/require-prop-types */
export default {
  name: 'Login',
  mixins: [validationMixin, ConverEmailToLowerCase],
  props: ['email'],
  data: () => ({
    errorEmailOrPassword: false,
    userDoesNotExist: false,
    showPassword: false,
    pageObjName: 'login',
    login: {
      email: null,
      password: null,
    },
  }),
  validations: {
    login: {
      email: {
        required, email,
      },
      password: {
        required, minLength: minLength(8),
      },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.login.email.$dirty) return errors;
      if (!this.$v.login.email.email) {
        errors.push('Invalid e-mail address');
      }
      if (!this.$v.login.email.required) {
        errors.push('Please enter required value');
      }
      if (this.userDoesNotExist) {
        errors.push('User does not exist');
      }
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.login.password.$dirty) return errors;
      if (!this.$v.login.password.minLength) {
        errors.push('Passwords must be at least 8 characters long');
      }
      if (!this.$v.login.password.required) {
        errors.push('Please enter required value');
      }
      if (this.errorEmailOrPassword) {
        errors.push('Incorrect Email or Password');
      }
      return errors;
    },
  },
  created() {
    localStorage.removeItem('subscribedPdfs');
    if (this.email) {
      this.initialCaseEmail = this.email;
    }
  },
  methods: {
    clearLoginErrorMessage(criteria) {
      if (criteria === 'password') {
        this.errorEmailOrPassword = false;
      } else {
        this.userDoesNotExist = false;
      }
    },
    signIn() {
      this.$v.login.$touch();
      if (!this.$v.login.$invalid) {
        this.$store.commit('spinner', true);
        const dataToSend = {
          email: this.login.email,
          password: this.login.password,
        };
        AWS.login(dataToSend, this);
      }
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
